<template>
  <div class="content-box" :class="{'m': isM }">
    <img :src="getPic()" width="100%" alt="" class="bg_img">
    <div class="content">
      <div class="head">四川繁羽开天科技有限公司游戏许可及服务协议</div>
      <div class="section">
        <span>《四川繁羽开天科技有限公司游戏许可及服务协议》（下称《协议》）由您与四川繁羽开天科技有限公司游戏服务提供方共同缔结，本协议具有合同效力。请您务必审慎阅读、充分理解各条款内容，特别是免除或者限制四川繁羽开天科技有限公司游戏责任的条款，以及开通或使用某项服务的单独协议。除非您已阅读并接受本协议所有条款，否则您无权使用四川繁羽开天科技有限公司游戏及服务。</span>
        <span class="boldT">用户使用四川繁羽开天科技有限公司游戏及服务即视为已阅读并同意签署本协议。如用户未满18周岁，请在法定监护人的陪同下阅读本协议并特别注意未成年人使用条款。</span>
      </div>
      <div class="section">
        <div class="boldT line">【重要提示】</div>
        <span class="boldT">1.用户在使用四川繁羽开天科技有限公司游戏软件及相关各项服务之前，请仔细阅读本《四川繁羽开天科技有限公司游戏许可及服务协议》中各项条款。特别是其中免除或者限制四川繁羽开天科技有限公司游戏责任的条款（通常含有“不负任何责任”、“无义务”等词汇）以及免除、限制用户权利的条款（通常含有“不得”等词汇）。对于以上条款，四川繁羽开天科技有限公司将在最大范围内以加黑加粗的方式予以表述。</span>
      </div>
      <div class="section">
        <span class="boldT">2.请用户审慎阅读并选择接受或不接受本协议（未成年人或非为完全民事行为能力人应在监护人陪同下阅读）。除非用户同意并接受本《协议》中的各条款，否则将无权接收、下载、安装、启动、升级、登录、显示、运行（以下统称“使用”）四川繁羽开天科技有限公司游戏提供的服务，亦无权使用该项服务的某项功能或某一部分。用户使用四川繁羽开天科技有限公司游戏提供的服务或者使用该服务的某项功能、某一部分的行为，即视为同意并接受本《协议》，愿意接受本《协议》各条款的约束。</span>
      </div>
      <div class="section">
        <span class="boldT">3.由于用户及市场状况的不断变化，四川繁羽开天科技有限公司游戏将会不定期地以“玩家条例”、“用户守则”、“封号规则”、公告等补充协议的形式对本《协议》进行补充、修订，该等补充协议将会在四川繁羽开天科技有限公司游戏官方网站上对外公布，而不另行对用户进行个别通知。用户应当实时查阅并了解这些补充协议，若用户不同意补充协议的内容，可停止使用四川繁羽开天科技有限公司游戏所提供的服务。若用户继续使用四川繁羽开天科技有限公司游戏所提供的服务，则视为用户业已同意遵守补充协议的相关内容。该补充协议是本《协议》不可分割的组成部分，与本《协议》具有同等法律效力。该等补充协议与本《协议》有矛盾或者冲突的地方，适用该等补充协议；没有涉及的内容，仍适用本《协议》的有关约定；</span>
      </div>
      <div class="section">
        <span class="boldT">4.用户在使用四川繁羽开天科技有限公司游戏提供的各项服务之后，如用户不再同意本《协议》及/或补充协议内容的，请停止使用四川繁羽开天科技有限公司游戏提供的服务；</span>
      </div>
      <div class="section">
        <span class="boldT">5.四川繁羽开天科技有限公司游戏将按照相关法律法规和本协议的规定，采取切实有效的措施保护未成年人在使用四川繁羽开天科技有限公司游戏服务过程中的合法权益，包括可能采取技术措施、禁止未成年人接触不适宜的游戏或者游戏功能、限制未成年人的游戏时间、预防未成年人沉迷网络。其他玩家在使用四川繁羽开天科技有限公司游戏服务的过程中应避免发布、产生任何有损未成年人身心健康的内容，共同营造健康的游戏环境；</span>
      </div>
      <div class="section">
        <span class="boldT">6.本《协议》签署于成都市高新区，因签订、履行本《协议》产生的任何纠纷，双方有权协商解决，在协商不成的情况下，任何一方有权向《协议》签署地有管辖权人民法院提起诉讼。</span>
      </div>
      <div class="section">
        <div class="boldT line">【正文】</div>
        <div class="boldT line">1.关于本许可使用</div>
        <div class="line">本许可使用的内容是指四川繁羽开天科技有限公司游戏允许用户使用四川繁羽开天科技有限公司游戏提供的游戏软件许可及服务（以下简称“本服务”）。</div>
        <div class="line">1.2 用户使用本服务需要在四川繁羽开天科技有限公司游戏官方网站或其他有权第三方渠道下载游戏客户端软件并完成注册账号、设置密码，并在遵循游戏规则、相关通告、玩家条例的前提下进行使用。</div>
        <div class="line">1.3在用户遵守本协议及相关法律法规的前提下，四川繁羽开天科技有限公司游戏给予用户一项个人的、不可转让及非排他性的许可，用户仅可为访问或使用本服务目的且非商业目的的使用这些软件及服务。</div>
        <div class="line">1.4 本条及本《协议》其他条款未明示许可的其他一切权利仍由四川繁羽开天科技有限公司游戏保留，四川繁羽开天科技有限公司游戏未行使，并不构成对该权利的放弃。</div>
        <div class="line"></div>
        <span class="line"></span>
        <span class="boldT"></span>
      </div>
      <div class="section">
        <div class="boldT line">2.知识产权声明</div>
        <div class="line">2.1 四川繁羽开天科技有限公司游戏或者其相关合作方、关联方依法享有游戏软件的一切合法权属（包括但不限于知识产权）。本软件的全部著作权、商标权及一切其他知识产权，以及与本软件相关的所有信息内容，包括但不限于：文字表述及其组合、图标、图饰、图表、色彩组合、界面设计、版面框架、有关数据、印刷材料、或电子文档等均受中国知识产权相关法律法规和有关的国际条约的保护。</div>
        <div class="line">2.2 四川繁羽开天科技有限公司游戏及其合作方、关联公司并未因为本《协议》或者因为向用户提供游戏软件以及相关服务而授予用户任何与本游戏软件相关的知识产权。</div>
        <div class="line">2.3 用户未经合法授权不得擅自复制、反编译（de-compile）、反汇编（disasemble）任何功能或程序，不得对任何功能和/或程序进行反向工程（reverse engineering），不得从事以下任何自行开发、使用或进行一切商业化运作等一系列侵犯游戏软件知识产权的行为，否则四川繁羽开天科技有限公司游戏将保留追究用户法律责任的权利。包括但不限于：</div>
        <div class="line">（1）复制、翻拷、传播和陈列本软件的程序、使用手册和其它图文音像资料的全部或部分内容；</div>
        <div class="line">（2）修改、翻译、注释、整理、汇编、演绎本软件，包括修改或遮盖本软件程序、图像、动画、包装和手册等内容上的产品名称、公司标志、版权信息等内容；</div>
        <div class="line">（3）出租、销售本软件或者利用本软件从事营利行为</div>
        <div class="line">（4）其它违反著作权法、计算机软件保护条例和相关法律法规的行为。</div>
      </div>
      <div class="section">
        <div class="boldT">2.4 四川繁羽开天科技有限公司游戏的游戏运行画面、美术素材、音乐素材及相应的衍生作品（虚拟及实物）的知识产权归属于四川繁羽开天科技有限公司游戏。</div>
      </div>
      <div class="section">
        <div class="line">2.5用户在使用四川繁羽开天科技有限公司游戏服务过程中不得未经四川繁羽开天科技有限公司许可以任何方式录制、直播或向他人传播四川繁羽开天科技有限公司游戏内容，包括但不限于不得利用任何第三方软件进行网络直播、传播等。</div>
      </div>
      <div class="section">
        <div class="boldT">2.6尽管本协议有其他约定，用户在使用四川繁羽开天科技有限公司游戏服务中产生的游戏数据的所有权和知识产权归四川繁羽开天科技有限公司游戏所有，四川繁羽开天科技有限公司游戏有权保存、处置该游戏数据。</div>
      </div>
      <div class="section">
        <div class="boldT line">3.游戏软件下载</div>
        <div class="boldT line">3.1 四川繁羽开天科技有限公司游戏仅许可用户在四川繁羽开天科技有限公司游戏官网或其他有权第三方渠道下载游戏客户端软件，对于用户通过其他非法途径下载客户端软件而引发的损失，将视为用户未获得四川繁羽开天科技有限公司游戏授权，四川繁羽开天科技有限公司游戏无法保证该游戏能够正常使用，并对因此给用户造成的损失不予负责。</div>
        <div class="line">3.2 四川繁羽开天科技有限公司游戏可能为不同的终端设备或操作系统开发了不同的软件版本，包括但不限于ios、android（包括模拟器版本）、windows phone等多个应用版本，用户应当根据实际情况选择下载合适的版本进行安装，下载安装程序后，用户需要按照该程序提示的步骤正确安装。</div>
        <div class="line">3.3 为提供更加优质、安全的服务，在软件安装时四川繁羽开天科技有限公司游戏可能推荐用户安装其他软件，用户可以选择安装或不安装。</div>
        <div class="line">3.4 如果用户不再需要使用该软件或者需要安装新版本，可以自行卸载。如果用户愿意帮助四川繁羽开天科技有限公司游戏改进产品服务，请告知卸载的原因。</div>
        <div class="line">3.5 为了保证游戏服务的安全性和功能的一致性，四川繁羽开天科技有限公司游戏有权不经向用户特别通知而对软件进行更新，或者对软件的部分功能效果进行改变或限制。</div>
        <div class="line">3.6 软件新版本发布后，旧版本的软件可能无法使用。四川繁羽开天科技有限公司游戏不保证旧版本软件继续可用及提供相应的客户服务，请用户随时核对并下载最新版本。</div>
      </div>
      <div class="section">
        <div class="boldT line">4.游戏账号及支付</div>
        <div class="line">4.1 如果用户接受本次许可使用，则需要按照相关法律法规的要求进行注册和使用四川繁羽开天科技有限公司游戏的相关服务，包括按照国家法律法规的相关要求，登录实名注册系统并进行实名注册。</div>
        <div class="line"></div>
        <div class="boldT line">4.2 用户充分理解并同意，四川繁羽开天科技有限公司游戏可能会按照国家相关要求将用户的实名注册信息（包括相关实名认证及年龄情况等）运用于防沉迷系统之中，即四川繁羽开天科技有限公司游戏可能会根据用户的实名注册信息判断用户是否年满18周岁、用户提交的实名身份信息是否规范或实名验证是否通过等，从而决定是否对用户的游戏账号予以防沉迷限制。</div>
        <div class="boldT line">4.3 用户进一步知悉并同意，根据相关法律法规和监管规定，用户账号须实名注册后才能使用四川繁羽开天科技有限公司游戏的产品/服务、进行游戏充值或消费。且一旦用户卸载或重装四川繁羽开天科技有限公司游戏，或用户更换手机等终端设备或该等终端设备损坏的，用户的所有游戏相关数据可能都将会被清空，且无法查询和恢复。如因此造成用户任何损失的，均由用户自行承担。</div>
        <div class="line">
          <span class="boldT">4.4 用户应妥善保管用户的游戏账号及其密码，因用户自身原因导致游戏账号及密码被窃取、丢失而引发的损失，由用户自行承担。</span>
          <span>如用户使用第三方账号作为游戏账号使用和享受四川繁羽开天科技有限公司游戏的，用户还应遵守有关该第三方账号的协议、规则，且因该第三方账号产生的相关问题包括但不限于被盗等，用户应自行联系该第三方进行解决，四川繁羽开天科技有限公司游戏可视情况提供相应的协助。</span>
        </div>
        <div class="boldT line">4.5用户充分理解并同意：为提高游戏服务的安全水平，四川繁羽开天科技有限公司游戏有权将有关技术或软件应用到游戏中，但四川繁羽开天科技有限公司游戏不保证这些安全保障措施可以完全杜绝游戏账号被他人窃取或丢失的风险。</div>
        <div class="boldT line">4.6 用户充分理解并同意：若四川繁羽开天科技有限公司游戏依照相关业务规则限制、冻结或终止用户的游戏账号，该游戏账号下的游戏数据及相关信息将被删除，由此引发相关权益的丧失，该损失由用户自行承担，对此四川繁羽开天科技有限公司游戏不承担任何责任。</div>
        <div class="boldT line">4.7 四川繁羽开天科技有限公司游戏有权监督用户账号使用情况， 在出现违反本协议相关违规时，则四川繁羽开天科技有限公司游戏有权作出独立的判断并采取相应的措施，该措施包括但不限于向有权机关进行举报，限制用户帐号的登陆，限制用户在游戏中的活动，终止本软件授权，删除与复制有关的物品（包括复制出的虚拟物品和参与复制的虚拟物品），删除用户的帐号并要求用户赔偿因从事上述行为而给四川繁羽开天科技有限公司游戏造成的损失等。</div>
        <div class="boldT line">4.8 用户在四川繁羽开天科技有限公司游戏提供的单款游戏产品中申请注册四川繁羽开天科技有限公司游戏账号的，将可以通过该四川繁羽开天科技有限公司游戏账号登录和使用四川繁羽开天科技有限公司游戏旗下的所有产品/服务。四川繁羽开天科技有限公司游戏账号是四川繁羽开天科技有限公司按照本协议授权给用户登录、使用四川繁羽开天科技有限公司游戏及相关服务的标识，其所有权属于四川繁羽开天科技有限公司。用户依本《协议》而获得游戏软件及游戏账号的使用权，有权在遵循本《协议》、支付规则的前提下使用支付账户购买游戏道具、游戏装备、游戏币等，支付账户及其密码由用户自行掌握，因用户自身原因导致支付账户名称、密码泄露而遭受的损失，由用户自行承担。</div>
        <div class="boldT line">4.9用户充分理解并同意：游戏装备、游戏币及其他游戏道具等是四川繁羽开天科技有限公司游戏服务的一部分，四川繁羽开天科技有限公司在此许可用户依本协议而获得其使用权。用户购买、使用游戏装备、游戏币及其他游戏道具等应遵循本协议、游戏具体规则的要求。同时，游戏装备、游戏币及其他游戏道具等可能受到一定有效期限的限制，即使用户在规定的有效期内未使用，除不可抗力或可归责于四川繁羽开天科技有限公司的原因外，一旦有效期届满，将会自动失效。如相关游戏币、游戏装备及其他游戏道具等游戏物品没有标明使用期限，或者标明的使用期限为“永久”或其他具有与“永久”相同或类似意思的内容的（如“无限期”、“无限制”等），则其使用期限为自用户获得该游戏物品之日起至该游戏终止运营之日止。</div>
        <div class="line">用户充分理解并同意：为更好地向用户提供四川繁羽开天科技有限公司游戏服务，四川繁羽开天科技有限公司有权对游戏相关内容（包括但不限于游戏角色、游戏装备及其他游戏道具的设计、性能及相关数值设置等）作出调整、更新或优化。</div>
        <div class="line">4.10四川繁羽开天科技有限公司向用户提供游戏服务本身属于商业行为，用户有权自主决定是否根据四川繁羽开天科技有限公司自行确定的收费项目（包括但不限于购买游戏内的虚拟道具的使用权以及接受其他增值服务等各类收费项目）及收费标准支付相应的费用，以获得相应的游戏服务。如用户不按相应标准支付相应费用的，用户将无法获得相应的游戏服务。</div>
      </div>
      <div class="section">
        <div class="boldT">用户知悉并同意：收费项目或收费标准的改变、调整是一种正常的商业行为，用户不得因为收费项目或收费标准的改变、调整而要求四川繁羽开天科技有限公司进行赔偿或补偿。</div>
      </div>
      <div class="section">
        <div class="boldT">用户知悉并同意，用户使用法定货币进行游戏充值购买或兑换游戏虚拟货币、虚拟道具及其他虚拟物品或增值服务的，视为用户购买了游戏服务，用户所购买或兑换的游戏虚拟货币、虚拟道具及其他虚拟物品或增值服务将不能退还或兑换成法定货币，但法律另有强制性规定的除外。</div>
      </div>
      <div class="section">
        <div class="boldT">用户知悉并同意，如用户进行游戏充值购买或兑换游戏虚拟货币的交易因退款等原因被取消的，四川繁羽开天科技有限公司游戏有权就该被取消的交易对应下发到用户游戏账号中的虚拟货币进行扣除。如用户游戏账号中的虚拟货币不足以扣除的，就不足部分，四川繁羽开天科技有限公司游戏可在用户游戏账号中的虚拟货币后续增加时优先扣除。</div>
      </div>
      <div class="section">
        <div class="boldT line">4.11 四川繁羽开天科技有限公司游戏特别提示用户不要从任何第三方通过购买、接受赠与或者其他的方式获得游戏账号、游戏道具、游戏装备、游戏币等，四川繁羽开天科技有限公司游戏不对第三方交易的行为负责，并且不受理因任何第三方交易发生纠纷而带来的申诉。</div>
        <div class="line">4.12 在四川繁羽开天科技有限公司游戏提供账号注销功能或服务的情形下，如用户需要账号注销的，可按照官方提供的账号注销指引或通过四川繁羽开天科技有限公司游戏官网“客服中心”联系客服进行操作，并应保证满足游戏官方公布的有关游戏账号注销的相关条件，同时同意游戏官方公布的游戏账号注销协议和其他有关规则。</div>
        <div class="boldT">同时也特别提示用户， 如用户注销账号的，该账号下的相关游戏收益也将会被清除。据此，在用户注销账号前请用户确保已妥善处理相应账号下的游戏收益或相关的游戏收益已结清。一旦用户注销账号，如届时相关游戏账号下还存在游戏收益的（包括在本游戏使用期间已产生的及未来可能产生的游戏收益），四川繁羽开天科技有限公司游戏有权对该账号下的全部游戏收益做清除处理，因此产生的后果由用户自行承担。前述游戏收益包括但不限于：游戏会员权益、等级；与游戏角色成长升级相关的所有数据（包括但不限于经验值、荣誉值、声望值、称号等）；尚未使用的网络游戏虚拟货币、虚拟道具及其他虚拟物品（如卡券、金币、钻石、道具及其他等）；已经购买但未到期或未使用完的增值服务；已产生但未消耗完毕的其他游戏收益或未来预期的游戏收益等。</div>
      </div>
      <div class="section">
        <div class="boldT line">5.用户信息收集、使用及保护</div>
        <div class="line">5.1 用户同意并授权四川繁羽开天科技有限公司游戏为履行本《协议》之目的收集和使用（“使用”包括但不限于提取、分析、存储、传输等行为）用户的信息，这些信息包括但不限于用户注册时提供的个人信息、游戏账号下的游戏数据以及其他在使用游戏服务的过程中提供的信息。</div>
        <div class="line">5.2 用户充分理解并同意：为能够正常提供游戏服务，四川繁羽开天科技有限公司游戏有权在必要的合理范围内将部分用户信息自行或通过关联公司、第三方技术供应商对用户的用户信息进行整理、统计、分析及利用。</div>
        <div class="line">5.3 四川繁羽开天科技有限公司游戏保证在符合发行地法律规定的范围内使用用户信息。</div>
        <div class="line">5.4 四川繁羽开天科技有限公司游戏承诺在未获得用户授权时不对外公开或向任何第三方提供用户信息，但是存在下列情形之一的除外：</div>
        <div class="line">（1）公开或提供相关信息之前获得用户授权或许可的；</div>
        <div class="line">（2）根据法律或政策的规定而公开或提供的；</div>
        <div class="line">（3）为用户获取四川繁羽开天科技有限公司游戏游戏服务的必要；</div>
        <div class="line">（4）根据行政、司法的执行令状要求公开或提供的；</div>
        <div class="line">（5）根据本《协议》约定而公开或提供的。</div>
        <div class="line">5.5 四川繁羽开天科技有限公司游戏不同产品对用户的用户信息收集、使用及保护等请求根据产品功能的不同而发生变化，具体内容将遵循《四川繁羽开天科技有限公司游戏隐私政策》等相关约定。除法律另有规定外，如用户已同意或授权四川繁羽开天科技有限公司游戏依据前述协议或规定收集、使用或处理涉及用户的个人信息的，在用户撤回该同意或授权后，不影响四川繁羽开天科技有限公司游戏在此之前已基于用户的同意或授权所进行的个人信息的收集、使用或处理，四川繁羽开天科技有限公司游戏对此前相关个人信息收集、使用或处理继续有效。</div>
        <div class="line">5.6 四川繁羽开天科技有限公司游戏将不断改进技术措施和运营方案，尽可能对用户信息的收集、使用及保护采用更严格的标准、流程和措施。</div>
        <div class="boldT line">5.7 用户应对通过四川繁羽开天科技有限公司游戏及相关服务了解、接收或可接触到的包括但不限于其他用户在内的任何人的个人信息予以充分尊重，用户不应以搜集、复制、存储、传播或以其他任何方式使用其他用户的个人信息，否则，由此产生的后果由用户自行承担。</div>
      </div>
      <div class="section">
        <div class="boldT line">6.用户守则</div>
        <div class="line">6.1使用四川繁羽开天科技有限公司游戏软件，用户必须：</div>
        <div class="line">（1）认真阅读并知晓四川繁羽开天科技有限公司游戏软件的产品介绍，遵守本协议和相关操作规则;</div>
        <div class="line">（2）提供设备，如手机或其他上网设备;</div>
        <div class="line">（3）个人上网和支付与此服务有关的费用;</div>
        <div class="line">（4）遵守中华人民共和国相关法律法规(如果用户是中华人民共和国境外的使用者，还应遵守所属国家或地区的法律法规)。</div>
        <div class="boldT line">6.2 用户在使用四川繁羽开天科技有限公司游戏软件时，不得利用四川繁羽开天科技有限公司游戏软件制作、复制、发布、传播以下信息或指向该等信息的链接及二维码：</div>
        <div class="boldT line">（1）含有侵犯他人知识产权、肖像权、名誉权、隐私权等合法权益的信息的;</div>
        <div class="boldT line">（2）违反宪法确定的基本原则的;</div>
        <div class="boldT line">（3）危害国家安全，泄露国家秘密，颠覆国家政权，破坏国家统一的;</div>
        <div class="boldT line">（4）损害国家荣誉和利益的;</div>
        <div class="boldT line">（5）煽动民族仇恨、民族歧视，破坏民族团结的;</div>
        <div class="boldT line">（6）破坏国家宗教政策，宣扬邪教和封建迷信的;</div>
        <div class="boldT line">（7）散布谣言，扰乱社会秩序，破坏社会稳定的;</div>
        <div class="boldT line">（8）散布淫秽、色情、赌博、暴力、恐怖或者教唆犯罪的;</div>
        <div class="boldT line">（9）侮辱或者诽谤他人，侵害他人合法权益的;</div>
        <div class="boldT line">（10）煽动非法集会、结社、游行、示威、聚众扰乱社会秩序的;</div>
        <div class="boldT line">（11）以非法民间组织名义活动的;</div>
        <div class="boldT line">（12）含有法律、行政法规禁止的其他内容的。</div>
        <div class="boldT line">6.3 用户应保证不得从事下列行为：</div>
        <div class="boldT line">（1）修改、翻译、注释、改编、整理、演绎四川繁羽开天科技有限公司游戏软件产品;</div>
        <div class="boldT line">（2）复制、翻拷、传播和陈列本应用产品的程序、使用手册和(或)其他图文音像资料的全部或部分内容;</div>
        <div class="boldT line">（3）通过反向工程、反向编译、反汇编或其他任何手段对四川繁羽开天科技有限公司游戏软件软件产品进行分析、修改、攻击、衍生;</div>
        <div class="boldT line">（4）通过任何方式探测、拦截、获取、使用四川繁羽开天科技有限公司游戏软件产品源代码及/或存储于四川繁羽开天科技有限公司游戏软件中的任何信息;</div>
        <div class="boldT line">（5）创作四川繁羽开天科技有限公司游戏软件的派生、衍生作品;</div>
        <div class="boldT line">（6）删除、掩盖或更改四川繁羽开天科技有限公司游戏或任何第三方的版权声明、商标或其它知识产权声明;</div>
        <div class="boldT line">（7）删除、掩盖或更改四川繁羽开天科技有限公司游戏软件所展现的任何信息;</div>
        <div class="boldT line">（8）利用四川繁羽开天科技有限公司游戏软件可能存在的技术缺陷或漏洞而以任何形式为自己或他人谋利或者从事其他不正当行为;</div>
        <div class="boldT line">（9）使用任何方式或方法、试图攻击提供四川繁羽开天科技有限公司游戏软件产品及相关各项服务的相关服务器、路由器、交换机以及其他设备，以达到非法获得或修改未经授权的数据资料、影响正常的四川繁羽开天科技有限公司游戏软件服务秩序，以及其他危害性目的的行为;</div>
        <div class="boldT line">（10）通过异常或者非法方法使用四川繁羽开天科技有限公司游戏软件产品及其相关各项服务，恶意破坏四川繁羽开天科技有限公司游戏软件软件产品，扰乱正常的服务秩序或者实施其他不正当行为;</div>
        <div class="boldT line">（11）制作、发布、传播、使用任何形式的妨碍四川繁羽开天科技有限公司游戏软件相关各项服务的辅助工具或程序;</div>
        <div class="boldT line">（12）盗取或使用他人账号或密码登录/使用四川繁羽开天科技有限公司游戏软件;</div>
        <div class="boldT line">（13）任何方式破坏、干扰四川繁羽开天科技有限公司游戏软件产品及其相关各项服务，或影响四川繁羽开天科技有限公司游戏品牌形象、公司利益的行为。</div>
        <div class="boldT line">6.4 用户在使用四川繁羽开天科技有限公司游戏软件时，不得损害、禁用、影响四川繁羽开天科技有限公司游戏的其他服务或使四川繁羽开天科技有限公司游戏的其他服务负担过重，也不得影响任何其它方享用四川繁羽开天科技有限公司游戏的其他服务。如果用户对四川繁羽开天科技有限公司游戏软件有任何意见，或有如何改进的建议，可向四川繁羽开天科技有限公司游戏提出。请注意，如果这样做，还会授予四川繁羽开天科技有限公司游戏和第三方在四川繁羽开天科技有限公司游戏软件(或第三方软件)中无偿使用和加入用户的建议或意见的权利。</div>
        <div class="boldT line">6.5 用户不得从事其他危害网络秩序，侵害四川繁羽开天科技有限公司游戏及其合作方、关联方合法权益，或影响四川繁羽开天科技有限公司游戏服务的正常进行的行为。</div>
        <div class="boldT line">6.6 用户不得从事违反本协议任何约定，或违反国家法律法规任何规定的行为，或其他在行业内被广泛认可的不当行为。</div>
        <div class="boldT line">6.7四川繁羽开天科技有限公司游戏倡议用户对自己的言行负责，文明游戏，健康游戏。用户不得通过各种方式在游戏中向其他玩家散布或传播虚假信息；不得宣扬非法网站；不得在游戏中通过各种方式散布或传播言行不雅的信息；不得传播相同的、类似短语或无实质意义的内容，以及任何与所在游戏无关的信息(包括但不限于刷屏等)，或者发布、传播任何贬损、诋毁、恶意攻击所在游戏或四川繁羽开天科技有限公司游戏的信息或者其他不实信息；不得通过各种方式或途径在游戏中从事引起地区纷争的行为；不得通过各种方式散布或传播代练信息；不得出现不符合法律法规、社会公德或游戏规则的骚扰情形。</div>
        <div class="boldT line">6.8用户在使用四川繁羽开天科技有限公司游戏产品或服务过程中如有以上任何行为（以下也称“违法违规行为”）之一的，四川繁羽开天科技有限公司有权视情节严重程度，依据本协议及相关游戏规则的规定，对用户采取以下一种或多种处理措施，并可公告处理结果：</div>
        <div class="boldT line">（1）警告；及/或</div>
        <div class="boldT line">（2）禁言，包括但不限于游戏全区禁言、单区禁言以及公共频道禁言；及/或</div>
        <div class="boldT line">（3）内容重置，包括但不限于重置或强制修改用户提供或上传的非法昵称、房间名、图片等非法信息或内容等；及/或</div>
        <div class="boldT line">（4）减少或限制用户的游戏收益，该游戏收益包括但不限于游戏中与游戏角色成长升级相关的所有数据（如经验值、荣誉值、声望值、称号等）的提升以及游戏中的道具、装备、虚拟货币等虚拟物品的获取；及/或</div>
        <div class="boldT line">（5）删除或注销游戏账号、游戏数据或其他游戏相关信息；及/或</div>
        <div class="boldT line">（6）限制或禁止用户进入游戏中的特定场景或使用游戏特定功能；及/或</div>
        <div class="boldT line">（7）强制退出游戏（即“踢出游戏”），包括但不限于强制退出整个游戏，或游戏中的单局对战，或用户正在进行中的其他游戏行为；及/或</div>
        <div class="boldT line">（8）暂时或永久性地禁止用户游戏账号登录四川繁羽开天科技有限公司游戏（以下称“封号”）；及/或</div>
        <div class="boldT line">（9）暂时或永久性地禁止用户违法违规行为涉及的特定终端（包括但不限于移动终端等）登录四川繁羽开天科技有限公司游戏；及/或</div>
        <div class="boldT line">（10）暂停或终止用户使用四川繁羽开天科技有限公司游戏及相关服务，或单方通知用户终止本协议；及/或</div>
        <div class="boldT line">（11）就用户的违法违规行为提起相应民事诉讼，追究用户的侵权、违约或其他民事责任，并要求用户赔偿四川繁羽开天科技有限公司游戏因用户违法违规行为所受到的损失（包括四川繁羽开天科技有限公司游戏所受到的直接经济损失、名誉或商誉损失以及四川繁羽开天科技有限公司游戏对外支付的赔偿金、和解费用、律师费用、诉讼费用及其他间接损失），或移交有关行政管理机关给予行政处罚，或者移交司法机关追究用户的刑事责任；及/或</div>
        <div class="boldT line">（12）四川繁羽开天科技有限公司通过游戏规则（包括但不限于用户守则、玩家条例、游戏公告、提示及通知）公布的其他处理措施。</div>
        <div class="boldT line">6.9用户知悉并同意，如四川繁羽开天科技有限公司游戏依据本协议对用户的游戏账号采取封号处理措施的，具体封号期间由四川繁羽开天科技有限公司游戏根据用户违规行为情节而定。</div>
      </div>
      <div class="section">
        <div class="boldT line">用户知悉并同意：</div>
        <div class="boldT line">（1）在封号期间，用户游戏账号中的游戏虚拟货币、游戏装备、游戏币及其他游戏道具可能都将无法使用；</div>
        <div class="boldT line">（2）如前述游戏虚拟货币、游戏装备、游戏币及其他游戏道具存在一定有效期，该有效期可能会在封号期间过期，用户游戏账号解封后，用户将无法使用该等已过期的游戏虚拟货币、游戏装备、游戏币及其他游戏道具。</div>
      </div>
      <div class="section">
        <span>6.10用户充分理解并同意：为营造公平、健康的游戏环境，在用户使用四川繁羽开天科技有限公司游戏服务的过程中，</span>
        <span class="boldT">四川繁羽开天科技有限公司游戏有权通过技术手段了解用户终端设备的随机存储内存以及与四川繁羽开天科技有限公司游戏同时运行的相关程序。</span>
        <span>一经发现有任何未经授权的，危害四川繁羽开天科技有限公司游戏正常运营的相关程序，四川繁羽开天科技有限公司游戏将收集所有与此相关的信息并采取合理措施予以打击。</span>
      </div>
      <div class="section">
        <div class="boldT line">7.免责声明</div>
        <div class="boldT line">7.1 四川繁羽开天科技有限公司游戏以游戏软件的“现状”提供给用户。四川繁羽开天科技有限公司游戏不保证：四川繁羽开天科技有限公司游戏游戏服务无错误及不会中断、所有缺陷已被更正，或四川繁羽开天科技有限公司游戏游戏服务不会受到病毒或任何其它因素的损害。</div>
        <div class="boldT line">7.2 除非有法律明确规定，四川繁羽开天科技有限公司游戏在此明确声明不承担任何明示或默示的担保责任，包括但不限于对四川繁羽开天科技有限公司游戏游戏服务的性能、适用性或不侵权的担保。</div>
        <div class="boldT line">7.3 四川繁羽开天科技有限公司游戏软件可能因游戏软件BUG、版本更新缺陷、第三方病毒攻击或其他任何因素导致用户的游戏角色、游戏道具、游戏装备及游戏币等账号数据发生异常。在数据异常的原因未得到查明前，四川繁羽开天科技有限公司游戏有权暂时冻结该游戏账号；若查明数据异常为非正常游戏行为，四川繁羽开天科技有限公司游戏有权恢复游戏账号数据至异常发生前的原始状态（包括向第三方追回被转移数据），且四川繁羽开天科技有限公司游戏无须向用户承担任何责任。</div>
        <div class="boldT line">7.4 用户充分理解到：第三方在四川繁羽开天科技有限公司游戏软件中投放的广告、链接或者其它形式的推广内容，均是由其自行提供的，用户应当自行判断其真实性，四川繁羽开天科技有限公司游戏对其推广内容不作任何明示或者默示的担保。</div>
        <div class="boldT line">7.5 用户充分理解到：不同操作系统之间存在不互通的客观情况，该客观情况并非四川繁羽开天科技有限公司游戏造成，由此可能导致用户在某一操作系统中的充值和游戏数据不能顺利转移到另一操作系统中。由于用户在不同系统进行切换造成的充值损失和游戏数据丢失风险应由用户自行承担，不得要求四川繁羽开天科技有限公司游戏承担任何责任。</div>
        <div class="boldT line">7.6 用户充分理解到：四川繁羽开天科技有限公司提供的游戏中可能会设置强制对战区域或玩法，如果用户不同意强制对战，请用户不要进入该游戏或游戏区域。用户的进入，将被视为同意该玩法并接受相应后果。</div>
        <div class="boldT line">7.7 游戏内虚拟物品交易存在的风险，四川繁羽开天科技有限公司游戏禁止用户私下进行游戏账号、虚拟物品的交易行为，四川繁羽开天科技有限公司游戏将不对该交易中产生的任何问题进行支持和保障，并可能对私下交易行为进行处罚，包括但不限于冻结物品、封停账号等。</div>
        <div class="boldT line">7.8 四川繁羽开天科技有限公司游戏在任何情况下均不向用户承担因履行本《协议》而产生的任何惩戒性、特殊性、附带性、间接性或继发性损害赔偿，无论该损害赔偿是基于违反合同或担保、侵权或任何其他法律理论。四川繁羽开天科技有限公司游戏向用户赔偿的上限为用户向四川繁羽开天科技有限公司游戏因充值而实际支付但尚未消费的法定货币金额。</div>
      </div>

      <div class="section">
        <div class="boldT line">8.服务的变更、中断或终止</div>

        <div class="line">8.1 如因系统维护或升级的需要而需暂停网络服务，四川繁羽开天科技有限公司游戏将尽可能事先进行通告。</div>
        <div class="line">8.2 用户提供虚假注册身份信息，或实施违反本《协议》的行为，四川繁羽开天科技有限公司游戏采取中止措施应当通知用户并告知中止期间，中止期间应该是合理的，中止期间届满四川繁羽开天科技有限公司游戏应当及时恢复对用户的服务。</div>
        <div>
          <span>8.3 除前述情形外，四川繁羽开天科技有限公司游戏终止运营网络游戏，或者网络游戏运营权发生转移的，将提前予以公告。用户以法定货币实际购买但尚未使用的网络游戏虚拟货币及尚未失效的游戏服务，按用户购买时的价格，以法定货币退还用户或者用户接受的其他方式进行退换。</span>
          <span class="boldT">四川繁羽开天科技有限公司游戏特别提示用户，用户网络游戏虚拟货币及游戏服务消耗的规则为，优先消耗用户以法定货币实际购买的网络游戏虚拟货币及游戏服务，其次再消耗以各种方式赠送的网络游戏虚拟货币及游戏服务。</span>
        </div>
      </div>
      <div class="section">
        <div class="boldT line">9.管辖与法律适用</div>
        <div class="boldT line">9.1 本《协议》签署地为中华人民共和国成都市高新区。</div>
        <div class="boldT line">9.2 本《协议》的成立、生效、履行、解释及纠纷解决，适用中华人民共和国大陆地区法律。</div>
        <div class="boldT line">9.3 因使用四川繁羽开天科技有限公司游戏所提供服务的用户之间发生纠纷的，也可向四川繁羽开天科技有限公司游戏的客服人员投诉并举证。用户需提供与其账号注册信息一致的个人有效身份证件、必要的国家行政或司法机关文件和其他本公司要求提供的相关证据。经四川繁羽开天科技有限公司游戏审核确认后，可以给予必要的协助和支持。</div>
        <div class="boldT line">9.4 用户对四川繁羽开天科技有限公司游戏的服务有任何异议的，可以向四川繁羽开天科技有限公司游戏的客服人员投诉并举证。查证属实的，四川繁羽开天科技有限公司游戏将立即更正并按照现行法律规定及本《协议》之约定执行。</div>
        <div class="boldT line">9.5 若用户和四川繁羽开天科技有限公司游戏之间因本《协议》发生任何纠纷或争议，首先应友好协商解决；协商不成的，用户同意将纠纷或争议提交至本《协议》签署地有管辖权的人民法院管辖。</div>
        <div class="line">9.6 本《协议》所有条款的标题仅为阅读方便，本身并无实际涵义，不能作为本《协议》涵义解释的依据。</div>
        <div class="line">9.7 本《协议》条款无论因何种原因部分无效，其余条款仍有效，对各方具有约束力。</div>
    </div>
      <div class="section">
        <div class="line">10.其他</div>
        <div class="line">10.1 根据国家新闻出版总署关于健康游戏的忠告，四川繁羽开天科技有限公司游戏提醒用户：抵制不良游戏，拒绝盗版游戏；注意自我保护，谨防受骗上当；适度游戏益脑，沉迷游戏伤身。</div>
        <div class="line">10.2 本《协议》适用于四川繁羽开天科技有限公司网络技术有限公司及其关联公司（包括但不限于四川繁羽开天科技有限公司传媒有限公司及/或其关联公司）提供的所有游戏产品及服务。</div>
        <div class="line">10.3 如果用户对本《协议》或四川繁羽开天科技有限公司游戏服务有意见或建议，可与四川繁羽开天科技有限公司游戏客户服务部门联系，我们会给予用户必要的帮助。</div>
      </div>
      <div class="section">
        <div class="line">四川繁羽开天科技有限公司</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "yh",
  data(){
    return {
      isM: false
    }
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      // 确保组件实例创建后再执行 scrollTo
      vm.$nextTick(() => {
        window.scrollTo(0, 0);
      });
    });
  },
  beforeDestroy() {
    window.scrollTo(0, 0);
    this.isM = false;
  },
  activated() {
    this.isM = window.innerWidth <= 750
  },
  created() {
    this.isM = window.innerWidth <= 750
  },
  methods: {
    getPic() {
      return this.isM ? require(`imgM/ys_bg.jpg`) : require(`img/ys_bg.jpg`);
    }
  }
}
</script>

<style scoped lang="less">

.content-box{
  font-size: .24rem;
  color: #2c3e50;

  .content{
    position: absolute;
    left: 0;
    top: 0;
    box-sizing: border-box;
    width: 100%;
    z-index: 1;
    padding: 1rem 3rem;
    text-align: left;
    font-size: .24rem;
    line-height: .32rem;

    .head{
      font-size: .4rem;
      font-weight: bold;
      text-align: center;
      margin-bottom: 1rem;
    }
    .section{
      margin-bottom: .6rem;
      font-size: .24rem;
      .boldT{
        font-weight: bold;
        font-size: .24rem;
      }
      .line{
        margin-bottom: .16rem;
        font-size: .24rem;
      }
      span{
        font-size: .24rem;
      }
    }
  }
}
.content-box.m{
  font-size: .24rem;
  color: #2c3e50;

  .content{
    position: absolute;
    left: 0;
    top: 0;
    box-sizing: border-box;
    width: 100%;
    z-index: 1;
    padding: .4rem .3rem;
    text-align: left;
    font-size: .24rem;
    line-height: .32rem;

    .head{
      font-size: .4rem;
      font-weight: bold;
      text-align: center;
      margin-bottom: 1rem;
      line-height: .5rem;
    }
    .section{
      margin-bottom: .4rem;
      font-size: .24rem;
      .boldT{
        font-weight: bold;
        font-size: .24rem;
      }
      .line{
        margin-bottom: .16rem;
        font-size: .24rem;
      }
      span{
        font-size: .24rem;
      }
    }
  }
}

</style>


// WEBPACK FOOTER //
// src/views/yh.vue